import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";

import axiosInstance from "utils/axiosInstance";

import UserInfoQuestionForm from "./UserInfoQuestionForm";

const UserInfoQuestionEditor = ({ t }) => {

  const navigate = useNavigate();

  //--------------------------------------------------
  // States
  //--------------------------------------------------
  const { infoQuestionId } = useParams();
  const [infoQuestion, setInfoQuestion] = useState({
    label: "",
    verifyRuleAI: [],
    verifyRuleHuman: [],
    dependencies: {
      activationConditionSets: [],
      affectedAttributes: [],
    },
  });
  const [prevQuestions, setPrevQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  //--------------------------------------------------
  // Initial Fetch
  //--------------------------------------------------
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get(`/knovia/myInfo/userInfoQuestion/${infoQuestionId}`);
      setInfoQuestion(response.data);
      console.log('infoQuestion:', response.data);

      const prevQuestionsResponse = await axiosInstance.get(`/knovia/myInfo/userInfoQuestion/${infoQuestionId}/getPrevQuestions`);
      console.log('prevQuestionsResponse.data:', prevQuestionsResponse.data);
      setPrevQuestions(prevQuestionsResponse.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [infoQuestionId]);

  //--------------------------------------------------
  // Callback on Save
  //--------------------------------------------------
  const handleSave = async (partialData) => {
    try {
      console.log('Sending partialData:', partialData);

      const response = await axiosInstance.patch(
        `/knovia/myInfo/userInfoQuestion/${infoQuestionId}`,
        partialData
      );

      console.log('Save successful.');

      setInfoQuestion((prev) => {
        let updated = { ...prev };
        console.log('prev:', prev);
        for (const key in partialData) {
          console.log(key, partialData[key]);
          if (typeof partialData[key] === 'object' && partialData[key] !== null && !Array.isArray(partialData[key])) {
            // It's an object (like dependencies)
            updated[key] = {
              ...updated[key],
              ...partialData[key],
            };
          } else {
            // It's a primitive field (like label or verifyRuleAI array)
            updated[key] = partialData[key];
          }
        }

        return updated;
      });

    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  const handleSaveRoles = async (newRoles) => {
    try {
      console.log('Sending roles:', newRoles);

      const response = await axiosInstance.patch(
        `/knovia/myInfo/userInfoQuestion/${infoQuestionId}/roles`,
        newRoles
      );

      console.log('Roles save successful.');

      setInfoQuestion((prev) => {
        let updated = { ...prev };

        for (const key in partialData) {
          console.log(key, partialData[key]);
          if (typeof partialData[key] === 'object' && partialData[key] !== null && !Array.isArray(partialData[key])) {
            // It's an object (like dependencies)
            updated[key] = {
              ...updated[key],
              ...partialData[key],
            };
          } else {
            // It's a primitive field (like label or verifyRuleAI array)
            updated[key] = partialData[key];
          }
        }

        return updated;
      });

    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  //--------------------------------------------------
  // Rendering Logic
  //--------------------------------------------------
  /*
  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!infoQuestion) return <div>No data found.</div>;
  */

  //--------------------------------------------------
  // Render
  //--------------------------------------------------
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>

              <Row className="mb-3 mb-md-0">
                <Col xs={4}>
                  <CardTitle className="mb-4">{t("編輯題目")}</CardTitle>
                </Col>
                <Col xs={8} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <Button color="info" style={{ padding: "7px 8px" }}
                    onClick={(e) => { 
                      navigate(`/myInfo/editQuestionSet/${typeof infoQuestion.questionSet === 'object' ? infoQuestion.questionSet._id : infoQuestion.questionSet}`);
                    }}
                  >
                    <i className='bx bx-arrow-back' ></i>{` 回到問題群組`}
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <UserInfoQuestionForm
                    infoQuestion={infoQuestion}
                    setInfoQuestion={setInfoQuestion}
                    prevQuestions={prevQuestions}
                    onSave={handleSave}
                    onSaveRoles={handleSaveRoles}
                  />
                </Col>
              </Row>

            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(UserInfoQuestionEditor);


